/* Vloerenthuis.nl — gedeeld script voor categorie- en productpagina's (Shopify: assets/shop.js) */
(() => {
  const eur = n => "€ " + n.toLocaleString("nl-NL", {minimumFractionDigits: 2, maximumFractionDigits: 2});

  const addSample = (h, q) => { if (window.VT) VT.add(h, q || 1); };

  /* categorie: filter op tint */
  const grid = document.getElementById("grid");
  document.querySelectorAll(".chip[data-f]").forEach(ch => ch.addEventListener("click", () => {
    const f = ch.dataset.f;
    document.querySelectorAll(".chip[data-f]").forEach(x => x.setAttribute("aria-pressed", x === ch));
    let i = 0;
    grid.querySelectorAll(".pcard").forEach(card => {
      const show = f === "alle" || card.dataset.tone === f;
      card.hidden = !show;
      if (show) { card.style.setProperty("--i", i++); card.style.animation = "none"; void card.offsetWidth; card.style.animation = ""; }
    });
  }));

  /* product: galerij */
  const main = document.getElementById("galMain");
  if (main) {
    const img = document.getElementById("galImg"), tag = document.getElementById("galTag");
    document.querySelectorAll(".gal__thumbs button").forEach(b => b.addEventListener("click", () => {
      document.querySelectorAll(".gal__thumbs button").forEach(x => x.setAttribute("aria-current", x === b));
      main.classList.remove("zoomed");
      img.classList.add("is-out");
      const n = new Image();
      n.onload = () => { img.src = n.src; img.alt = b.dataset.alt; tag.textContent = b.dataset.tag; img.classList.remove("is-out"); };
      n.src = b.dataset.src;
    }));
    const zoom = document.getElementById("galZoom");
    zoom.addEventListener("click", () => { main.classList.toggle("zoomed"); zoom.setAttribute("aria-label", main.classList.contains("zoomed") ? "Zoom uit" : "Zoom in op de foto"); });
    zoom.addEventListener("pointermove", e => {
      const r = main.getBoundingClientRect();
      main.style.setProperty("--zx", ((e.clientX - r.left) / r.width * 100) + "%");
      main.style.setProperty("--zy", ((e.clientY - r.top) / r.height * 100) + "%");
    });
  }

  /* product: prijs voor jouw m² */
  const mini = document.getElementById("mini");
  if (mini) {
    const P = JSON.parse(mini.dataset.p), qty = document.getElementById("qty"), lev = document.getElementById("lev") || {checked: false, addEventListener(){}}, tot = document.getElementById("tot");
    let shown = P.price * 30;
    const calc = () => {
      const n = Math.max(1, Math.round(+qty.value || 0)), target = n * (P.price + (lev.checked ? P.level : 0)), from = shown, t0 = performance.now();
      const step = now => { const t = Math.min(1, (now - t0) / 350); shown = from + (target - from) * (1 - Math.pow(1 - t, 3)); tot.textContent = eur(shown); if (t < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    };
    mini.querySelectorAll("[data-d]").forEach(b => b.addEventListener("click", () => { qty.value = Math.max(5, (+qty.value || 0) + +b.dataset.d); calc(); }));
    qty.addEventListener("input", calc); lev.addEventListener("change", calc);
    const buy = document.getElementById("buyBtn");
    if (buy) buy.addEventListener("click", () => {
      /* In Shopify: /cart/add.js met de variant "zonder leggen" en quantity = aantal m² (of pakken) */
      addSample(P.handle, Math.max(1, Math.round(+qty.value || 0))); buy.textContent = "In je winkelwagen ✓"; buy.classList.add("is-added");
    });
    const sb = document.getElementById("sampleBtn");
    sb.addEventListener("click", () => { addSample(P.sample, 1); sb.textContent = "Testpak in je winkelwagen ✓"; sb.classList.add("is-added"); });
  }
})();

/* binnenkijken: filter + lightbox */
(() => {
  const grid = document.getElementById("bkgrid");
  document.querySelectorAll(".chip[data-bf]").forEach(ch => ch.addEventListener("click", () => {
    document.querySelectorAll(".chip[data-bf]").forEach(x => x.setAttribute("aria-pressed", x === ch));
    let i = 0;
    grid.querySelectorAll(".bkc").forEach(c => { const show = ch.dataset.bf === "alle" || c.dataset.p === ch.dataset.bf; c.hidden = !show; if(show){ c.style.setProperty("--i", i++); c.style.animation = "none"; void c.offsetWidth; c.style.animation = ""; } });
  }));
  const lb = document.getElementById("lb"); if(!lb) return;
  const img = document.getElementById("lbImg"), cap = document.getElementById("lbCap"), close = document.getElementById("lbClose");
  let last = null;
  const shut = () => { lb.hidden = true; if(last) last.focus(); };
  document.querySelectorAll(".bkg__open").forEach(b => b.addEventListener("click", () => {
    last = b; img.src = b.dataset.full; img.alt = b.querySelector("img").alt; cap.textContent = b.dataset.cap; lb.hidden = false; close.focus();
  }));
  close.addEventListener("click", shut);
  lb.addEventListener("click", e => { if(e.target === lb) shut(); });
  document.addEventListener("keydown", e => { if(e.key === "Escape" && !lb.hidden) shut(); });
})();

document.querySelectorAll(".menu-btn").forEach(b => {
  const h = b.closest(".header"), set = o => { h.classList.toggle("is-open", o); b.setAttribute("aria-expanded", o); b.setAttribute("aria-label", o ? "Sluit menu" : "Menu"); };
  b.addEventListener("click", () => set(!h.classList.contains("is-open")));
  h.querySelectorAll(".nav a").forEach(a => a.addEventListener("click", () => set(false)));
  document.addEventListener("keydown", e => { if(e.key === "Escape") set(false); });
});

/* categorie: prijs inclusief / zonder leggen */
(() => {
  const seg = document.querySelector(".ptog__seg"); if(!seg) return;
  const set = mode => {
    seg.querySelectorAll("button").forEach(b => b.setAttribute("aria-pressed", b.dataset.mode === mode));
    document.body.classList.toggle("is-loose", mode === "out");
    document.querySelectorAll("[data-in][data-out]").forEach(el => { el.textContent = el.dataset[mode]; });
  };
  seg.addEventListener("click", e => { const b = e.target.closest("button[data-mode]"); if(b) set(b.dataset.mode); });
})();

document.querySelectorAll(".nav__top").forEach(t => {
  const g = t.parentElement;
  t.addEventListener("click", () => { const o = !g.classList.contains("is-open"); document.querySelectorAll(".nav__grp.is-open").forEach(x => { x.classList.remove("is-open"); x.firstElementChild.setAttribute("aria-expanded", false); }); g.classList.toggle("is-open", o); t.setAttribute("aria-expanded", o); });
});
document.addEventListener("click", e => { if(!e.target.closest(".nav__grp")) document.querySelectorAll(".nav__grp.is-open").forEach(x => { x.classList.remove("is-open"); x.firstElementChild.setAttribute("aria-expanded", false); }); });
